import React from 'react';
import cx from 'classnames';
import s from '../Profile.scss';

function Textarea({ className, label, input, required, id, placeholder, maxLength, meta: { error } }) {
  return (
    <div className={cx(s.TextareaWrap, className)}>
      <label htmlFor="text-about">{label}</label>
      <textarea
        cols="30"
        rows="10"
        placeholder={placeholder}
        className={s.Textarea}
        {...input}
      />
      {
        maxLength &&
        <span className={cx(s.Message, { [s.Error]: error })}>
          {input.value.length}/{maxLength}
        </span>
      }
    </div>
  );
}

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/Textarea.js